import { Resource } from '../resource'


export class City extends Resource {
    uid: string | any
    name: string | any
}


